import { css } from 'styled-components';
export const reworkDefaults = css `
  font: var(--paragraph-font);
  color: var(--text);
  width: 86rem;
  max-width: 100%;
  border-radius: var(--border-radius-sm);
  border: 0.1rem solid (--border);
`;
export const reworkCalendarHeader = css `
  border-bottom: 0.2rem solid var(--border);
  border-radius: var(--border-radius-sm) var(--border-radius-sm) 0 0;
`;
export const reworkCalendarDays = css `
  padding: 0 0 0.5rem;
`;
export const reworkCalendarDOW = css `
  font: var(--paragraph-small-font);
  color: var(--text);
  padding: 0 0;
`;
export const reworkCalendarDay = css `
  height: 3.2rem;

  // remove circle hover effect
  &:hover {
    &::before {
      background-color: transparent;
    }
  }
`;
export const reworkCalendarDayOutside = css `
  visibility: hidden;
  pointer-events: none;
`;
export const reworkMonthContainer = css `
  // overriding weird inline styiling, remove important if you figure out where it is added
  width: 100% !important;
  max-width: 100% !important;
  box-shadow: rgba(0, 174, 239, 0.2) 0 1rem 4rem 0;
  border-radius: var(--border-radius-sm);
`;
